import React from "react";
import Music from "source/app/services/Sound/Music/Music";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { State } from "source/app/services/UI/State/State";
import styled from "styled-components";
import { IMusicMenuState } from "../Music/IMusicMenuState";

export function AdjustMusicVolume({ volume }: { volume: number }) {
    return (
        <Container>
            <label htmlFor="customRange1" className="form-label">
                Music volume
            </label>
            <input
                type="range"
                className="form-range"
                min="0"
                max="1.0"
                step="0.1"
                value={volume}
                onChange={handleVolumeChange}
            />
        </Container>
    );
}

const handleVolumeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newVolume = parseFloat(event.target.value);

    const { currentMusicSoundFile } = State.ReadClass<IMusicMenuState>(
        ESharedComponent.MusicMenu
    ).state;
    
    currentMusicSoundFile?.volume(newVolume);

    State.ReadClass<IMusicMenuState>(ESharedComponent.MusicMenu).setState({
        currentVolume: newVolume,
    });
};

const Container = styled.div`
    opacity: 0.8;
`;
